import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const clinicApi = createApi({
  reducerPath: "clinicApi",
  baseQuery: fetchBaseQuery({ baseUrl: "https://n6t.in/console/clinics" }),
  endpoints: (builder) => ({
    getAllClinics: builder.query({
      query: (accessToken) => ({
        url: "/",
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    }),
    addClinic: builder.mutation({
      query: (accessToken, body) => ({
        url: "/",
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body,
      }),
    }),

    editClinic: builder.mutation({
      query: (accessToken, body, id) => ({
        url: `/${id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body,
      }),
    }),
    deleteClinic: builder.mutation({
      query: (accessToken, body, id) => ({
        url: `/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    }),
  }),
});

export const {
  useGetAllClinicsQuery,
  useAddClinicMutation,
  useEditClinicMutation,
  useDeleteClinicMutation,
} = clinicApi;

